import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation} from "@angular/core";
import {IButton} from "../button";

@Component({
	selector: 'cp-button-group',
	templateUrl: './button.group.template.html',
	styleUrls: ['./button.group.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated
})
export class ButtonGroupComponent {

	@Input() buttons: IButton[];
	@Input() buttonClass: string;
	@Output() selectionChanged:EventEmitter<IButton> = new EventEmitter<IButton>();


	public setButtonClasses(isFirst: boolean, isLast: boolean) {
		return {
			[this.buttonClass]: this.buttonClass !== undefined,
			first: isFirst,
			last: isLast
		};
	}

	onButtonClick(button: IButton) {
		this.selectionChanged.emit(button);
	}


}
